<div class="content-wrapper container-xxl p-0" *ngIf="currentAsset">
  <div class="content-body">
    <div class="d-flex" [ngClass.xl]="'justify-content-between'" [ngClass.md]="'flex-column'" [ngClass.sm]="'flex-column'">
      <div class="d-flex" [ngClass.sm]="'flex-column'">
        <app-content-header [contentHeader]="contentHeader"></app-content-header>
        <div class="d-flex" [ngClass.xl]="'flex-column'" [ngClass.md]="'flex-column'" [ngClass.sm]="'my-mt-n1'">
          <div *ngIf="currentAsset.assigned">
            <span class="badge badge-success mr-1" *ngIf="currentAsset.assigned">
              {{ "ASSIGN_MALE" | translate }}
            </span>
          </div>
          <div *ngIf="currentAsset.inMaintenance == 1">
            <span class="badge badge-danger" [ngClass.md]="'mr-1 mt-' + currentAsset.assigned" [ngClass.xl]="'mt-' + currentAsset.assigned" [ngClass.sm]="'mt-0'">
              {{ "IN_MAINTENANCE" | translate }}
            </span>
          </div>
        </div>
      </div>
      <div [ngClass.sm]="'d-flex justify-content-between my-1'" [ngClass.md]="'d-flex justify-content-end my-1'">
        <button
          type="button"
          class="btn btn-outline-primary"
          [ngClass.xl]="'mr-1'"
          [ngClass.md]="'mr-1 mb-05'"
          *ngIf="_authenticationService.hasCapability('create_maintenance_asset')"
          (click)="openModal(addMaintenance)"
        >
          {{ "ADD" | translate }} {{ "MAINTENANCE" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [ngClass.md]="'mb-05'"
          [ngClass.xl]="'mr-1'"
          *ngIf="currentAsset.assigned == false && _authenticationService.hasCapability('manage_assign_asset')"
          (click)="showModalAdd(idAsset)"
        >
          {{ "ASSOCIATE" | translate }}
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [ngClass.md]="'mb-05'"
          [ngClass.xl]="'mr-1'"
          *ngIf="currentAsset.assigned == true && _authenticationService.hasCapability('manage_assign_asset')"
          (click)="dissociateAsset()"
        >
          {{ "DISSOCIATE" | translate }}
        </button>
        <button type="button" class="btn btn-primary" [ngClass.md]="'mb-05'" [routerLink]="'/dashboard/assets/edit/' + currentAsset.id" *ngIf="_authenticationService.hasCapability('edit_asset')">
          {{ "EDIT" | translate }}
        </button>
      </div>
    </div>

    <div class="card">
      <div class="card-body">
        <div class="row">
          <!--seriale-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "INTERNAL_SERIAL" | translate }}: </label>
            <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ currentAsset.serial }}</p>
          </div>
          <!--seriale prodotto-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "PRODUCT_SERIAL_NUMBER" | translate }}: </label>
            <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ currentAsset.product_serial_number.length > 0 ? currentAsset.product_serial_number : ("" | translate) }}</p>
          </div>
          <!--categoria-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "CATEGORY" | translate }}: </label>
            <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ currentAsset.category_name }}</p>
          </div>
          <!--dipendente-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "EMPLOYEE" | translate }}: </label>
            <a
              *ngIf="currentAsset.assigned"
              class="font-medium-1"
              [ngClass.xl]="'d-block'"
              [ngClass.md]="'d-block'"
              [routerLink]="'/dashboard/user/profile/' + currentAsset.employee.user.hash"
              [ngClass.sm]="'mb-0 pl-05 d-inline-block'"
            >
              {{ currentAsset.employee.user.complete_name }}</a
            >
            <p *ngIf="!currentAsset.assigned" class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ "NO_EMPLOYEE" | translate }}</p>
          </div>
          <!--data d'assegnazione-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "ASSIGNED_DATE" | translate }}: </label>
            <p class="font-medium-1" *ngIf="currentAsset.assigned && currentAsset.employee.start_date" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ _utilService.formatDate(currentAsset.employee.start_date) }}</p>
            <p class="font-medium-1" *ngIf="!currentAsset.assigned && !currentAsset.employee.start_date" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ "NOT_ASSIGNED" | translate }}</p>
          </div>
          <!--contratto-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "CONTRACT" | translate }}: </label>
            <p class="font-medium-1" *ngIf="currentAsset.contract" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ currentAsset.contract }}</p>
            <p class="font-medium-1" *ngIf="!currentAsset.contract" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">-</p>
          </div>
          <!--data fine contratto-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "END_DATE_CONTRACT" | translate }}: </label>
            <p class="font-medium-1" *ngIf="currentAsset.contract_end_date" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ _utilService.formatDate(currentAsset.contract_end_date) }}</p>
            <p class="font-medium-1" *ngIf="!currentAsset.contract_end_date" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">-</p>
          </div>
          <!--noleggio-->
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "RENTAL" | translate }}:</label>
            <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ (currentAsset.rented ? "YES" : "NO") | translate }}</p>
          </div>
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "END_LICENSE" | translate }}:</label>
            <p class="font-medium-1" *ngIf="currentAsset.license_end_date" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ _utilService.formatDate(currentAsset.license_end_date) }}</p>
            <p class="font-medium-1" *ngIf="!currentAsset.license_end_date" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">-</p>
          </div>
          <div class="col-12 col-lg-3 col-md-6">
            <label class="font-small-4" [ngClass.sm]="'mb-05'">{{ "AUTOMATIC_RENEWAL" | translate }}:</label>
            <p class="font-medium-1" [ngClass.sm]="'mb-0 pl-05 d-inline-block'">{{ (currentAsset.license_auto_renew ? "YES" : "NO") | translate }}</p>
          </div>
          <!--caratteristiche-->
          <div class="col-12" [ngClass.xl]="'mt-1'">
            <label class="font-small-4 font-weight-bold">{{ "CHARACTERISTICS" | translate }}:</label>
            <p class="font-medium-1 mb-0" [innerHTML]="currentAsset.description"></p>
          </div>
          <!--note-->
          <div class="col-12 mt-1">
            <label class="font-small-4">{{ "NOTES" | translate }}:</label>
            <p class="font-medium-1 mb-0" *ngIf="currentAsset.employee.note" [innerHTML]="currentAsset.employee.note"></p>
            <p class="font-medium-1 mb-0" *ngIf="!currentAsset.employee.note">{{ "NO_NOTES" | translate }}</p>
          </div>
        </div>
      </div>
    </div>
    <div class="card">
      <!--bottoni-->
      <div class="card-body">
        <div class="d-flex" [ngClass.sm]="'flex-column'">
          <button
            [class]="'btn btn-' + (activeTab !== 'maintenance' ? 'outline-secondary' : 'light')"
            *ngIf="_authenticationService.hasCapability('view_maintenance_asset')"
            [ngClass.sm]="'w-100'"
            (click)="changeTab('maintenance')"
          >
            {{ "MAINTENANCE" | translate }}
          </button>
          <button
            [class]="'btn btn-' + (activeTab !== 'attachments' ? 'outline-secondary' : 'light')"
            *ngIf="_authenticationService.hasCapability('view_file_asset')"
            [ngClass.sm]="'w-100 my-05'"
            [ngClass.md]="'mx-1'"
            [ngClass.xl]="'ml-1'"
            (click)="changeTab('attachments')"
          >
            {{ "ATTACHMENTS" | translate }}
          </button>
          <button
            [class]="'btn btn-' + (activeTab !== 'oldEmployees' ? 'outline-secondary' : 'light')"
            *ngIf="_authenticationService.hasCapability('view_oldEmployees_asset')"
            [ngClass.sm]="'w-100'"
            [ngClass.xl]="'ml-1'"
            (click)="changeTab('oldEmployees')"
          >
            {{ "OLD_EMPLOYEE" | translate }}
          </button>
        </div>
      </div>

      <!--tab manutenzione desktop-->
      <div class="card-body p-0" *ngIf="activeTab == 'maintenance' && _utilService.isDesktop">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="50"
          [footerHeight]="50"
          [limit]="10"
          [rows]="currentAsset.maintenances"
        >
          <ngx-datatable-column [name]="'FROM' | translate" prop="from" [sortable]="true" width="50">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ _utilService.formatDate(row.from) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TO' | translate" prop="to" [sortable]="true" width="50">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TYPE' | translate" prop="type" [sortable]="true" width="50">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="text-capitalize">{{ row.type }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'CREATED_BY' | translate" prop="note" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/user/profile/' + row.creator.hash">{{ row.creator.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NOTES' | translate" [sortable]="false" width="300">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="text-break-line-1" [ngbTooltip]="row.note">{{ row.note }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'ACTIONS' | translate" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="d-flex align-items-center">
                <a class="text-secondary text-center" (click)="openModal(editMaintenance, row)" *ngIf="_authenticationService.hasCapability('edit_maintenance_asset')">
                  <span class="pr-1">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </span>
                </a>
                <a class="text-danger" (click)="deleteMaintenance(row)" *ngIf="_authenticationService.hasCapability('delete_maintenance_asset')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </a>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <!--tab manutenzione mobile-->
      <div class="card-body p-0" *ngIf="(activeTab == 'maintenance' && _utilService.isMobile) || (activeTab == 'maintenance' && _utilService.isTablet)">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [footerHeight]="40"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [limit]="10"
          [scrollbarH]="false"
          [rowHeight]="150"
          [rows]="currentAsset.maintenances"
        >
          <ngx-datatable-column [name]="'FROM' | translate" prop="from" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-6">
                  <span>{{ "FROM" | translate }}: {{ _utilService.formatDate(row.from) }}</span>
                </div>
                <div class="col-6">
                  <span>{{ "TO" | translate }}: {{ row.to ? _utilService.formatDate(row.to) : "-" }}</span>
                </div>
                <div class="col-12">
                  <a [routerLink]="'/dashboard/user/profile/' + row.creator.hash">{{ row.creator.complete_name }}</a>
                </div>
                <div class="col-6">
                  <span class="text-capitalize">{{ row.type }}</span>
                </div>
                <div class="col-6 d-flex align-items-center justify-content-center">
                  <a class="text-secondary text-center" (click)="openModal(editMaintenance, row)" *ngIf="_authenticationService.hasCapability('edit_maintenance_asset')">
                    <span class="pr-1">
                      <i [data-feather]="'edit-2'" size="19"></i>
                    </span>
                  </a>
                  <a class="text-danger" (click)="deleteMaintenance(row)" *ngIf="_authenticationService.hasCapability('delete_maintenance_asset')">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </a>
                </div>
                <div class="col-12 mt-1">
                  <span class="text-break-line-1" [ngbTooltip]="row.note">{{ row.note }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>

      <!--tab file desktop-->
      <div class="row" [ngClass.xl]="'mt-1'" *ngIf="activeTab == 'attachments' && _utilService.isDesktop">
        <angular-file-uploader class="col-4 pl-2" #assetUploader [resetUpload]="true" (fileSelected)="fileSelected()" [config]="afuConfig" (ApiResponse)="uploadFiles()"></angular-file-uploader>
        <div class="col-8">
          <div class="row">
            <div class="col-12" *ngIf="currentAsset.attachments.length > 0">
              <h5>{{ "FILE" | translate }}</h5>
            </div>
            <div class="col-10 d-flex justify-content-between align-items-center mb-05" *ngFor="let file of currentAsset.attachments; let i = index">
              <div>{{ file.filename }}</div>
              <div>
                <button type="button" (click)="openFile(currentAsset.attachments[i].url)" class="btn border-0 mr-2 px-0" [ngbTooltip]="'VIEW' | translate">
                  <span [data-feather]="'eye'" size="16"></span>
                </button>
                <a class="text-danger" (click)="deleteFileAsset(currentAsset.attachments[i].id)">
                  <span [data-feather]="'trash'" size="16"></span>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--tab file mobile-->
      <div class="card-body p-0" *ngIf="(activeTab == 'attachments' && _utilService.isMobile) || (activeTab == 'attachments' && _utilService.isTablet)">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="50"
          [rows]="currentAsset.attachments"
        >
          <ngx-datatable-column [name]="'FILE' | translate" prop="filename" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-9 pl-0 text-break-line-1">
                  {{ row.filename }}
                </div>
                <div class="col-2 d-flex align-items-center">
                  <button type="button" (click)="openFile(row.url)" class="btn border-0 mr-2 p-0" [ngbTooltip]="'VIEW' | translate">
                    <span [data-feather]="'eye'" size="16"></span>
                  </button>
                  <a class="text-danger" (click)="deleteFileAsset(row.id)">
                    <span [data-feather]="'trash'" size="16"></span>
                  </a>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>

      <!--tab vecchi dipendenti desktop-->
      <div class="card-body p-0" *ngIf="activeTab == 'oldEmployees' && _utilService.isDesktop">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="30"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="true"
          [rowHeight]="50"
          [footerHeight]="50"
          [rows]="currentAsset.oldEmployees"
          [limit]="10"
        >
          <ngx-datatable-column [name]="'FROM' | translate" prop="start_date" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ _utilService.formatDate(row.start_date) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'TO' | translate" prop="end_date" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ _utilService.formatDate(row.end_date) }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NAME' | translate" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <a [routerLink]="'/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'NOTES' | translate" [sortable]="false" width="600">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span class="text-break-line-1" [ngbTooltip]="row.note">{{ row.note }}</span>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
      <!--tab vecchi dipendenti mobile-->
      <div class="card-body p-0" *ngIf="(activeTab == 'oldEmployees' && _utilService.isMobile) || (activeTab == 'oldEmployees' && _utilService.isTablet)">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="50"
          [footerHeight]="40"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [limit]="10"
          [scrollbarH]="true"
          [rowHeight]="120"
          [rows]="currentAsset.oldEmployees"
        >
          <ngx-datatable-column [name]="'FROM' | translate" prop="start_date" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row list-item-mobile">
                <div class="col-6">
                  <span>{{ "FROM" | translate }}: {{ _utilService.formatDate(row.start_date) }}</span>
                </div>
                <div class="col-6">
                  <span>{{ "TO" | translate }}: {{ _utilService.formatDate(row.end_date) }}</span>
                </div>
                <div class="col-12">
                  <a [routerLink]="'/dashboard/user/profile/' + row.user.hash">{{ row.user.complete_name }}</a>
                </div>
                <div class="col-12">
                  <span class="text-break-line-1" [ngbTooltip]="row.note">{{ row.note }}</span>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>

<!--associa-->
<app-assets-associate-modal
  *ngIf="toggleModalAssociate && _authenticationService.hasCapability('manage_assign_asset')"
  [assetID]="AssetIdSelectedForAssociate"
  (callbackFn)="toggleModalAssociate = false"
  (onAssociate)="onAssociateModalFormEvent()"
></app-assets-associate-modal>

<!--aggiungi manutenzione-->
<ng-template #addMaintenance let-modal>
  <form [formGroup]="maintenanceGroup">
    <div class="modal-header">
      <div></div>
      <button type="button" class="close" (click)="closeModal()" aria-label="Close">
        <span aria-hidden="true">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <h3>{{ "ADD" | translate }} {{ "MAINTENANCE" | translate }}</h3>
      <div class="row">
        <div class="col-lg-4 col-md-6 col-6">
          <div class="form-group">
            <label class="col-form-label">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
            <ng2-flatpickr [config]="editFromSelectedMaintenance" [formControlName]="'from'"></ng2-flatpickr>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-6">
          <div class="form-group">
            <label class="col-form-label">{{ "TO" | translate }}</label>
            <ng2-flatpickr [config]="editToSelectedMaintenance" [formControlName]="'to'"></ng2-flatpickr>
          </div>
        </div>
        <div class="col-lg-4 col-md-6 col-12">
          <div class="form-group">
            <label class="col-form-label">{{ "MAINTENANCE" | translate }}<sup class="text-danger">*</sup></label>
            <ng-select class="{{ fieldHasErrors('type') ? 'is-invalid' : '' }}" [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [formControlName]="'type'">
              <ng-option [value]="'interna'">{{ "INTERNAL" | translate }}</ng-option>
              <ng-option [value]="'esterna'">{{ "ESTERNAL" | translate }}</ng-option>
            </ng-select>
            <div class="invalid-feedback" *ngIf="maintenanceGroup.controls.type.errors?.required">{{ "ERRORS.SELECT_MAINTENANCE" | translate }}</div>
          </div>
        </div>
        <div class="col-12">
          <div class="form-group">
            <label class="col-form-label">{{ "NOTES" | translate }}<sup class="text-danger">*</sup></label>
            <textarea name="description" class="form-control {{ fieldHasErrors('note') ? 'is-invalid' : '' }}" [formControlName]="'note'"></textarea>
            <div class="invalid-feedback" *ngIf="maintenanceGroup.controls.note.errors?.required">{{ "ERRORS.INSERT_NOTE" | translate }}</div>
            <div class="invalid-feedback" *ngIf="maintenanceGroup.controls?.note?.errors?.minlength">{{ "MIN" | translate }} 5 {{ "CHARACTERS" | translate }}</div>
            <div class="invalid-feedback" *ngIf="maintenanceGroup.controls?.note?.errors?.maxlength">{{ "MAX" | translate }} 255 {{ "CHARACTERS" | translate }}</div>
          </div>
        </div>
      </div>
    </div>
    <div class="modal-footer d-flex justify-content-center">
      <button type="button" class="btn btn-outline-primary w-150" (click)="closeModal()" rippleEffect>
        {{ "CANCEL" | translate }}
      </button>
      <button type="submit" (click)="createMaintenance()" class="btn btn-primary w-150" rippleEffect>
        {{ "ADD" | translate }}
      </button>
    </div>
  </form>
</ng-template>

<!--modifica manutenzione-->
<ng-template #editMaintenance let-modal>
  <div class="modal-header">
    <div></div>
    <button type="button" class="close" (click)="closeModal()" aria-label="Close">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body" *ngIf="selectedMaintenance">
    <h3>{{ "EDIT" | translate }} {{ "MAINTENANCE" | translate }}</h3>
    <div class="row">
      <div class="col-lg-4 col-md-6 col-6">
        <div class="form-group">
          <label class="col-form-label">{{ "FROM" | translate }}<sup class="text-danger">*</sup></label>
          <ng2-flatpickr [config]="editFromSelectedMaintenance" [(ngModel)]="selectedMaintenance.from"></ng2-flatpickr>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-6">
        <div class="form-group">
          <label class="col-form-label">{{ "TO" | translate }}</label>
          <ng2-flatpickr [config]="editToSelectedMaintenance" (keydown.backspace)="selectedMaintenance.to = null" [(ngModel)]="selectedMaintenance.to"></ng2-flatpickr>
        </div>
      </div>
      <div class="col-lg-4 col-md-6 col-12">
        <div class="form-group">
          <label class="col-form-label">{{ "MAINTENANCE" | translate }}<sup class="text-danger">*</sup></label>
          <ng-select [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true" [(ngModel)]="selectedMaintenance.type">
            <ng-option value="interna">{{ "INTERNAL" | translate }}</ng-option>
            <ng-option value="esterna">{{ "ESTERNAL" | translate }}</ng-option>
          </ng-select>
        </div>
      </div>
      <div class="col-12">
        <div class="form-group">
          <label class="col-form-label">{{ "NOTES" | translate }}<sup class="text-danger">*</sup></label>
          <textarea name="description" class="form-control" [(ngModel)]="selectedMaintenance.note"></textarea>
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer d-flex justify-content-center" *ngIf="selectedMaintenance">
    <button type="button" class="btn btn-outline-primary w-150" (click)="closeModal()" rippleEffect>
      {{ "CANCEL" | translate }}
    </button>
    <button [disabled]="!selectedMaintenance.from || !selectedMaintenance.type || !selectedMaintenance.note" type="submit" (click)="editCurrentMaintenance()" class="btn btn-primary w-150" rippleEffect>
      {{ "EDIT" | translate }}
    </button>
  </div>
</ng-template>
